import { render, staticRenderFns } from "./MoreEntrance.vue?vue&type=template&id=861214dc&scoped=true&"
import script from "./MoreEntrance.vue?vue&type=script&lang=ts&"
export * from "./MoreEntrance.vue?vue&type=script&lang=ts&"
import style0 from "./MoreEntrance.vue?vue&type=style&index=0&id=861214dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861214dc",
  null
  
)

export default component.exports